import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import { persistContractCase } from "../../Persist/ContractCasePersister";
import { stageMetaDataCase } from "../../Stages/StagesCase";
import * as caseStages from "../../Stages/StagesCase";
import * as caseStatus from "../../LeadStatus/StatusCase";
import contractTransformations from "../FormTransformations/contractTransformations";
import { stageFormDefinition as stageFormDefinitionContract } from "../FormDefinitions/contract/stageFormDefinition";
import { fullFormDefinition as fullFormDefinitionContract } from "../FormDefinitions/contract/fullFormDefinition";
import eventProductSpecificDefinition from "../FormDefinitions/eventContract";
import { contractCaseDetailsSpecialActions } from "../CaseDetailsSpecialActions/contractCaseDetailsSpecialActions";
import { getLitigationCaseBadges } from "../Badges/getLitigationCaseBadges";
import { litigationCaseSubBarAdditionalInformation } from "../CaseSubBarAdditionalInformation/litigationCaseSubBarAdditionalInformation";
import { inquiryTypeAvailability } from "../../inquiryService";
import {
  litigationCaseCourtAppointmentCreationAvailable,
  placeholderPaymentTypeSwitchData,
} from "./productServiceFunctions";
import { EventContract } from "../../../types/Products/ContractLaw/EventContract";
import { getProductData } from "./productService";

export const eventContract: ProductData<EventContract> = {
  urlPart: "veranstaltung",
  lbUrlPart: "veranstaltung",
  label: translate("eventContract.label"),
  generalLabel: "Beratung / Vertretung Vertragsrecht",
  apiUri: "event_contracts",
  persist: persistContractCase,
  stages: stageMetaDataCase,
  stageConstants: caseStages,
  minimumCaseStatus: caseStatus.STATUS_CREATED,
  minimumCaseStage: caseStages.STAGE_CREATED,
  setBackCaseStage: caseStages.STAGE_DATA_COMPLETED,
  paymentType: {
    insurance: "RSV",
  },
  paymentTypeSwitchData: placeholderPaymentTypeSwitchData,
  courtAppointmentCreationAvailable: litigationCaseCourtAppointmentCreationAvailable,
  lbProductClass: "App\\Entity\\Legalbird\\ContractLaw\\EventContract\\EventContract",
  formTransformations: contractTransformations,
  formDefinition: ({ product, currentUser }) => stageFormDefinitionContract(product, currentUser),
  formDefinitionExternals: ({ product }) => stageFormDefinitionContract(product)[product.stage],
  fullFormDefinition: ({ product, currentUser }) => fullFormDefinitionContract(product, currentUser),
  productSpecificDefinition: ({ product }) => eventProductSpecificDefinition(product),
  caseDetailsSpecialActions: ({ product }) => contractCaseDetailsSpecialActions(product),
  productCategory: "contractLaw",
  productSpecificBadges: ({ product }) => getLitigationCaseBadges(product),
  caseSubBarAdditionalInformation: ({ product, currentUser }) =>
    litigationCaseSubBarAdditionalInformation(product, currentUser),
  showCaseDescription: ({ product }) => {
    return product.stage >= getProductData(product.productClassName, "setBackCaseStage");
  },
  inquiryTypeAvailability: inquiryTypeAvailability.eventContract,
};
